import { normalizeAssetId } from './trackingModel';
import { activeDeploymentsForPerson, operationalAssets, personNamesMatch } from './deploymentUsageModel';

export function readTagAssetId(search = '') {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  return normalizeAssetId(params.get('asset') || params.get('gear') || '');
}

export function stripTagAssetQuery(url) {
  try {
    const parsed = new URL(url, 'https://line-medic.local');
    parsed.searchParams.delete('asset');
    parsed.searchParams.delete('gear');
    parsed.searchParams.delete('source');
    const suffix = parsed.searchParams.toString();
    return `${parsed.pathname}${suffix ? `?${suffix}` : ''}${parsed.hash || ''}`;
  } catch (_) {
    return '/my-gear';
  }
}

export function resolveTagHandoff(state, actorName, rawAssetId) {
  const assetId = normalizeAssetId(rawAssetId);
  if (!assetId) {
    return { assetId: '', asset: null, target: 'home', status: 'empty', message: '' };
  }

  const asset = operationalAssets(state).find(item => normalizeAssetId(item.id) === assetId) || null;
  if (!asset) {
    return {
      assetId,
      asset: null,
      target: 'home',
      status: 'missing',
      message: `${assetId} is registered on the tag, but the physical asset is not in Tracking yet.`,
    };
  }

  if (asset.currentDeploymentId) {
    const deployment = state.deployments.find(item => item.id === asset.currentDeploymentId) || null;
    if (deployment && personNamesMatch(deployment.person, actorName)) {
      return {
        assetId,
        asset,
        deployment,
        target: 'return',
        status: 'return',
        message: `${asset.name} recognized from its tag and added to your return.`,
      };
    }

    return {
      assetId,
      asset,
      deployment,
      target: 'home',
      status: 'deployed_other',
      message: `${asset.name} is currently assigned to ${deployment?.person || 'another deployment'}.`,
    };
  }

  if (asset.ownership === 'personal' && asset.personalOwner && !personNamesMatch(asset.personalOwner, actorName)) {
    return {
      assetId,
      asset,
      target: 'home',
      status: 'personal_other',
      message: `${asset.name} is personal gear assigned to ${asset.personalOwner}.`,
    };
  }

  if (asset.status === 'available' && asset.condition === 'ready') {
    const active = activeDeploymentsForPerson(state, actorName);
    if (active.length) {
      return {
        assetId,
        asset,
        target: 'home',
        status: 'active_deployment',
        message: `${asset.name} is ready, but you already have an active deployment. Return that deployment before starting another checkout.`,
      };
    }

    return {
      assetId,
      asset,
      target: 'deploy',
      status: 'deploy',
      message: `${asset.name} recognized from its tag and added to your deployment checkout.`,
    };
  }

  return {
    assetId,
    asset,
    target: 'home',
    status: 'not_ready',
    message: `${asset.name} cannot be checked out right now (${String(asset.status || 'unknown').replaceAll('_', ' ')} / ${String(asset.condition || 'unknown').replaceAll('_', ' ')}).`,
  };
}
